/* eslint-disable no-unused-expressions */
import { configure } from '..';
import { isFirefox } from '../helpers';
import { shareScreenToPatient } from '../helpers/waitingRoomSignalR';
import waitingRoomDispatcher from '../module/waiting-room/action/waitingRoom';
import { AGORA_APP_ID } from './config';
import { decodeSttPayload } from './decodeSttStreamMessage';
import { ROLE_TYPES } from '@/constants/roles';
import { romeoServiceSingleton } from '@/helpers/romeoServices';
import AgoraRTC from 'agora-rtc-sdk-ng';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';

const DOM_MAIN_VIDEO_AREA = 'main_stream';
const DOM_SUB_VIDEO_AREA = 'sub_stream';
const DOM_SUB_USER_VIDEO_AREA = 'sub_user_stream';
const HARDCODED_DOCTOR_UID = 1001;

class Agora4xInstance {
  constructor(appId) {
    this.rtc = {
      client: {
        instance: null,
        audioTrack: null,
        videoTrack: null,
      },
      remoteClient: {
        audioTrack: null,
        videoTrack: null,
      },
      shareScreenClient: {
        instance: null,
        screenTrack: null,
        uid: null,
      },
      localUserIds: [],
      remoteUserIds: [],
    };
    this.option = {
      appID: appId,
      channel: '',
      uid: null,
      token: null,
    };
    this.id = '';
    this.configInit = { mode: 'rtc', codec: 'h264' };
    this.configVideoTrack = { fit: 'contain' };
    this.initClient(appId);
  }

  initClient(appId = AGORA_APP_ID) {
    const { option, rtc, configInit, subscribeAudioAndVideoTracks } = this;
    option.appID = appId;

    rtc.client.instance = AgoraRTC.createClient(configInit);
    rtc.shareScreenClient.instance = AgoraRTC.createClient(configInit);
    subscribeAudioAndVideoTracks();
  }

  setOption = (option = {}) => {
    this.option = {
      ...this.option,
      ...option,
    };
  };
  getPendingConsultation = (accessToken) => {
    fetch(`${process.env.REACT_APP_CONSULTATION_HUB_URL}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        waitingRoomDispatcher.setState('pendingConsultationData', data);
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  joinChannel = async (channel = this.option.channel, shareScreen = false) => {
    try {
      const { rtc, createAndPublishLocalTracks, setOption } = this;
      const roleName = configure.store.getState().auth?.userInfo?.roleName;
      const isDoctor = roleName === ROLE_TYPES.DOCTOR;
      setOption({
        channel,
        uid: isDoctor && !shareScreen ? HARDCODED_DOCTOR_UID : null,
      });

      let clientInstance = !shareScreen
        ? rtc.client.instance
        : rtc.shareScreenClient.instance;

      const uid = await clientInstance.join(
        this.option.appID,
        this.option.channel,
        null,
        this.option.uid
      );
      rtc.localUserIds.push(uid);
      if (shareScreen) rtc.shareScreenClient.uid = uid;
      // Create local tracks, using microphone and camera
      createAndPublishLocalTracks(shareScreen, uid);
      console.log(
        'join channel: ' + this.option.channel + ' success, uid: ' + uid
      );
    } catch (err) {
      console.error('client join failed', err);
    }
  };

  leaveChannel = async ({ leaveOnlyShareScreen }) => {
    try {
      const hasTranscription =
        configure.store.getState().waitingRoom.hasTranscription;
      const accessToken = configure.store.getState().auth.accessToken;
      const callId = configure.store.getState().waitingRoom.callId;

      const { rtc, configVideoTrack } = this;
      let client = rtc.client.instance;

      // If leave only user
      if (client && !leaveOnlyShareScreen) {
        if (callId) {
          await romeoServiceSingleton.stopAgoraTranscriptionSession({
            sessionId: callId,
            token: accessToken,
          });
        }

        // Destroy the audio and video tracks of client and remote client
        rtc.client.videoTrack?.stop();
        rtc.client.videoTrack?.close();
        rtc.client.audioTrack?.stop();
        rtc.client.audioTrack?.close();
        rtc.client.videoTrack = null;
        rtc.client.audioTrack = null;

        waitingRoomDispatcher.setState('calling', false);
        waitingRoomDispatcher.setState('isMuteAudio', false);
        waitingRoomDispatcher.setState('isMuteVideo', false);
        waitingRoomDispatcher.setState('isMuteSpeaker', false);
        waitingRoomDispatcher.setState('isSharing', false);
        waitingRoomDispatcher.setState('showChat', false);
        if (hasTranscription) {
          romeoServiceSingleton.generateSummary(accessToken, callId);
          this.getPendingConsultation(accessToken);
        } else {
          waitingRoomDispatcher.setState('consConfirmVisibility', true);
        }
        waitingRoomDispatcher.updateRemoteStream([]);

        // Leave the channel.
        await client.leave();
        console.log('client leaves channel success');
      }

      // If leave only share screen
      if (rtc.shareScreenClient.instance && rtc.shareScreenClient.screenTrack) {
        const isTracksArray = isArray(rtc.shareScreenClient.screenTrack);
        const isTracksEmpty = isEmpty(rtc.shareScreenClient.screenTrack);

        if (isTracksArray && !isTracksEmpty) {
          for (const trackScreen of rtc.shareScreenClient.screenTrack) {
            await trackScreen.stop();
            await trackScreen.close();
          }
        } else {
          rtc.shareScreenClient.screenTrack?.stop();
          rtc.shareScreenClient.screenTrack?.close();
        }
        rtc.shareScreenClient.uid = null;
        rtc.shareScreenClient.screenTrack = null;
        // play remote client on main screen, play client on sub screen after turn off share screen
        // rtc.remoteClient.audioTrack?.play();
        // rtc.remoteClient.videoTrack?.play(DOM_MAIN_VIDEO_AREA, configVideoTrack);
        // rtc.client.videoTrack?.play(DOM_SUB_VIDEO_AREA, configVideoTrack);

        if (rtc.remoteClient?.audioTrack?.isPlaying)
          rtc.remoteClient.audioTrack?.play();

        if (rtc.remoteClient?.videoTrack?.isPlaying)
          rtc.remoteClient.videoTrack?.play(
            DOM_MAIN_VIDEO_AREA,
            configVideoTrack
          );

        waitingRoomDispatcher.setState('isSharing', false);
        await rtc.shareScreenClient.instance.leave();
      }
    } catch (err) {
      console.error('leaveChannel failed', err);
    }
  };

  createAndPublishLocalTracks = async (shareScreen, shareScreenUid) => {
    try {
      const {
        rtc,
        createTracks,
        playLocalTracks,
        subscribeShareScreenTrackEndedEvent,
      } = this;

      let tracks = await createTracks(shareScreen);

      let client = !shareScreen ? rtc.client : rtc.shareScreenClient;

      await client.instance.publish(tracks);

      //save track after publish success
      if (shareScreen && rtc.shareScreenClient.instance) {
        client.screenTrack = tracks;
        // Check if shareScreen track is array (return tracks with both audio and video)
        const isTracksArray = isArray(client.screenTrack);
        const isTracksEmpty = isEmpty(client.screenTrack);
        waitingRoomDispatcher.setState('isSharing', true);
        shareScreenToPatient(shareScreenUid);
        // subscribe for track-ended event
        subscribeShareScreenTrackEndedEvent(
          tracks,
          isTracksArray && !isTracksEmpty,
          shareScreen
        );
      } else {
        client.audioTrack = tracks[0];
        client.videoTrack = tracks[1];
        playLocalTracks(shareScreen, client.videoTrack, client.audioTrack);
      }

      console.log('publish success!');
    } catch (err) {
      const { rtc } = this;
      let clientInstance = !shareScreen
        ? rtc.client.instance
        : rtc.shareScreenClient.instance;
      waitingRoomDispatcher.setState('isSharing', false);
      await clientInstance.leave();
      console.log('publish failed');
      console.error(err);
    }
  };

  createTracks = async (shareScreen) => {
    if (!shareScreen) {
      // Capture and audio and video at one time

      const audioConfig = {
        encoderConfig: {
          sampleRate: 16000,
        },
      };

      const [audioTrack, videoTrack] =
        await AgoraRTC.createMicrophoneAndCameraTracks(
          audioConfig,
          undefined // video config mặc định
        );
      return [audioTrack, videoTrack];
    } else {
      let trackParams = {
        // Set the encoder configurations. For details, see the API description.
        encoderConfig: '1080p_1',
        // Set the video transmission optimization mode as prioritizing video quality.
        optimizationMode: 'detail',
      };
      if (isFirefox()) {
        trackParams.screenSourceType = 'window';
      }
      const screenTrack = await AgoraRTC.createScreenVideoTrack(
        trackParams,
        'auto'
      );
      return screenTrack;
    }
  };

  playLocalTracks = (shareScreen, videoTrack, audioTrack) => {
    const { rtc, configVideoTrack } = this;
    if (shareScreen && rtc.shareScreenClient.instance) {
      //stop local and remote video tracks only
      rtc.client.videoTrack?.stop();
      rtc.remoteClient.videoTrack?.stop();

      // play remote client on sub screen, play share screen on main screen
      if (audioTrack) {
        audioTrack.play();
      }

      if (videoTrack) {
        rtc.client.videoTrack?.play(DOM_SUB_VIDEO_AREA, configVideoTrack);
        rtc.remoteClient.videoTrack?.play(
          DOM_SUB_USER_VIDEO_AREA,
          configVideoTrack
        );
        videoTrack.play(DOM_MAIN_VIDEO_AREA, configVideoTrack);
      }
    } else videoTrack.play(DOM_SUB_VIDEO_AREA, configVideoTrack);
  };

  subscribeShareScreenTrackEndedEvent = (
    track,
    isArrayChecked,
    shareScreen
  ) => {
    const { rtc, playLocalTracks } = this;

    if (isArrayChecked) {
      const videoTrack = track.find(
        (track) => track?.trackMediaType === 'video'
      );
      videoTrack.on('track-ended', async () => {
        waitingRoomDispatcher.setState('isSharing', false);
        for (const trackScreen of rtc.shareScreenClient.screenTrack) {
          await trackScreen.stop();
          await trackScreen.close();
        }

        await rtc.shareScreenClient.instance.leave();
      });
      playLocalTracks(shareScreen, videoTrack);
    } else {
      track.on('track-ended', async () => {
        waitingRoomDispatcher.setState('isSharing', false);
        await rtc.shareScreenClient.screenTrack?.stop();
        await rtc.shareScreenClient.screenTrack?.close();
        await rtc.shareScreenClient.instance.leave();
      });
      playLocalTracks(shareScreen, track);
    }
  };

  subscribeAudioAndVideoTracks = async () => {
    const { rtc, configVideoTrack } = this;
    let client = rtc.client.instance;
    // Will be triggered when a remote user publishes an audio or video track
    client.on('user-published', async (user, mediaType) => {
      // Initiate the subscription
      // Prevent subscribing to your own streams (normal and share screen)
      rtc.remoteUserIds.push(user.uid);
      if (!rtc.localUserIds.includes(user.uid)) {
        await client.subscribe(user, mediaType);
      } else return;

      // If the remote user publishes a video track.
      if (mediaType === 'video') {
        // Get the RemoteVideoTrack object in the AgoraRTCRemoteUser object.
        const videoTrack = user.videoTrack;
        rtc.remoteClient.videoTrack = videoTrack;

        if (rtc.shareScreenClient.uid) {
          // play remote client on sub screen when sharing
          rtc.remoteClient.videoTrack?.play(
            DOM_SUB_USER_VIDEO_AREA,
            configVideoTrack
          );
          rtc.client.videoTrack?.play(DOM_SUB_VIDEO_AREA, configVideoTrack);
        } else {
          rtc.remoteClient.videoTrack?.play(
            DOM_MAIN_VIDEO_AREA,
            configVideoTrack
          );
          rtc.client.videoTrack?.play(DOM_SUB_VIDEO_AREA, configVideoTrack);
        }
      }
      // If the remote user publishes an audio track.
      if (mediaType === 'audio') {
        // Get the RemoteAudioTrack object in the AgoraRTCRemoteUser object.
        const audioTrack = user.audioTrack;
        const firstStartTranscription =
          configure.store.getState().waitingRoom.firstStartTranscription;
        const callProblem = configure.store.getState().waitingRoom.callProblem;

        console.log(
          '==> firstStartTranscription',
          firstStartTranscription,
          rtc.remoteClient.audioTrack
        );
        audioTrack?.play();
        rtc.remoteClient.audioTrack = audioTrack;

        if (firstStartTranscription && !callProblem) {
          // doctor websocket is initialized from romeoService.toggleRecording flow
        }
      }

      waitingRoomDispatcher.updateRemoteStream(
        [rtc.remoteClient.audioTrack, rtc.remoteClient.videoTrack].filter(
          (i) => i
        )
      );
    });

    // Will be triggered when a remote user unpublishes an audio or video track
    client.on('user-unpublished', (user, mediaType) => {
      if (mediaType === 'audio') {
      }
    });

    // Will be triggered when a remote user becomes offline.
    client.on('user-left', async (user) => {
      const id = user.uid;

      // check if share screen user
      if (rtc.shareScreenClient.uid === id) {
        //stop local and remote tracks
        rtc.client.audioTrack?.stop();
        rtc.client.videoTrack?.stop();
        rtc.remoteClient.audioTrack?.stop();
        rtc.remoteClient.videoTrack?.stop();
        rtc.shareScreenClient.uid = null;

        // play remote client on main screen, play client on sub screen
        rtc.remoteClient.audioTrack?.play();
        rtc.remoteClient.videoTrack?.play(
          DOM_MAIN_VIDEO_AREA,
          configVideoTrack
        );
        rtc.client.videoTrack?.play(DOM_SUB_VIDEO_AREA, configVideoTrack);
      }

      rtc.client.videoTrack?.play(DOM_SUB_VIDEO_AREA, configVideoTrack);
    });

    client.on('stream-message', (uid, payload) => {
      const botSttUid = 88888 || 66666;
      if (botSttUid != null && botSttUid !== '') {
        const expected = Number(botSttUid);
        const uidNum = Number(uid);
        const matches =
          (!Number.isNaN(expected) && uidNum === expected) ||
          String(uid) === String(botSttUid);
        if (!matches) return;
      }
      const result = decodeSttPayload(payload);

      if (!result.ok) {
        return;
      }

      const sttMessage = this.normalizeAgoraSttMessage(uid, result.data);
      if (!sttMessage) {
        return;
      }

      waitingRoomDispatcher.addMessage({
        transcript: sttMessage.transcript,
        start_time: sttMessage.start_time,
        end_time: sttMessage.end_time ?? sttMessage.start_time,
        speaker: sttMessage.speaker,
        is_final: sttMessage.is_final,
        role: sttMessage.role,
      });

      romeoServiceSingleton.sendDoctorTranscriptWs({
        transcript: sttMessage.transcript,
        start_time: sttMessage.start_time,
        end_time: sttMessage.end_time ?? sttMessage.start_time,
        speaker: sttMessage.speaker,
        is_final: sttMessage.is_final,
      });

      if (romeoServiceSingleton.onTranscriptUpdate) {
        romeoServiceSingleton.onTranscriptUpdate(
          romeoServiceSingleton.messagesDoctor
        );
      }
    });
  };

  /**
   * Who actually spoke (protobuf Text.uid). Stream-message uid is often the STT bot, not the speaker.
   */
  resolveAgoraSttSpeakerUid(streamUid, data) {
    if (data?.uid != null && String(data.uid) !== '') return data.uid;
    return streamUid;
  }

  resolveRoleBySpeakerUid(speaker) {
    const { rtc } = this;
    const localIds = rtc?.localUserIds || [];
    const remoteIds = rtc?.remoteUserIds || [];

    const speakerNum = typeof speaker === 'string' ? Number(speaker) : speaker;

    if (speakerNum === HARDCODED_DOCTOR_UID) return 'doctor';
    if (speakerNum != null) return 'patient';

    if (speakerNum != null && localIds.includes(speakerNum)) return 'doctor';
    if (speakerNum != null && remoteIds.includes(speakerNum)) return 'patient';

    return 'doctor';
  }

  normalizeAgoraSttMessage = (uid, data) => {
    if (!data || typeof data !== 'object') return null;

    const words = Array.isArray(data.words) ? data.words : [];
    const transcript = words
      .map((item) => item?.text)
      .filter((text) => typeof text === 'string' && text.trim().length > 0)
      .join(' ')
      .trim();
    if (!transcript) return null;

    const startTime = Number(data.time);
    const durationMs = Number(data.durationMs);
    const start_time = Number.isFinite(startTime) ? startTime : Date.now();
    const end_time =
      start_time +
      (Number.isFinite(durationMs) && durationMs > 0 ? durationMs : 0);

    const speaker = this.resolveAgoraSttSpeakerUid(uid, data);
    const role = this.resolveRoleBySpeakerUid(speaker);

    return {
      transcript,
      start_time,
      end_time,
      speaker,
      is_final: Boolean(words?.[0]?.isFinal),
      role,
    };
  };

  muteSpeaker = async (isMute) => {
    try {
      const { rtc } = this;
      waitingRoomDispatcher.setState('isMuteSpeaker', isMute);
      isMute
        ? rtc.remoteClient.audioTrack?.stop()
        : rtc.remoteClient.audioTrack?.play();
    } catch (err) {
      console.log('muteSpeaker failed');
      console.error(err);
    }
  };

  muteAudio = async (isMute) => {
    try {
      const { rtc } = this;
      waitingRoomDispatcher.setState('isMuteAudio', isMute);
      isMute
        ? rtc.client.audioTrack.setMuted(true)
        : rtc.client.audioTrack.setMuted(false);
    } catch (err) {
      console.log('muteAudio failed');
      console.error(err);
    }
  };

  muteVideo = async (isMute) => {
    try {
      const { rtc } = this;
      waitingRoomDispatcher.setState('isMuteVideo', isMute);
      rtc.client.videoTrack.setMuted(isMute);
    } catch (err) {
      console.log('muteVideo failed');
      console.error(err);
    }
  };
}

export default class NewAgoraInstance extends Agora4xInstance {
  static instance = Agora4xInstance.instance || new Agora4xInstance();
}

// Reset instance after end call
export const resetAgora4xInstance = () => {
  Agora4xInstance.instance = new Agora4xInstance();
};
